import { takeLatest, put, select } from 'redux-saga/effects';
import { getUserProperties, setUserProperty } from 'utils/userProperties';
import * as userProperties from 'actions/userProperties';
import {
  SET_PROFILE,
  SET_AUTH,
  SET_AUTH_FROM_API,
  SET_AUTH_FROM_LOCAL,
  LOGOUT,
} from 'actions/constants';
import { SET_USER_PROPERTY } from 'actions/userProperties/constants';
import getMokaUserId from 'selectors/getMokaUserId';

export function* reloadUserProperties() {
  const userId = yield select(getMokaUserId);
  if (!userId) {
    return;
  }
  const props = getUserProperties(userId);
  yield put(userProperties.loadUserProperties(props));
}

export function* saveUserProperty(request) {
  const userId = yield select(getMokaUserId);
  if (!userId) {
    return;
  }
  setUserProperty(userId, request.payload.key, request.payload.value);
}

export function* resetUserProperties() {
  yield put(userProperties.resetUserProperties());
}

export default function* saga() {
  yield takeLatest(
    [SET_AUTH, SET_PROFILE, SET_AUTH_FROM_API, SET_AUTH_FROM_LOCAL],
    reloadUserProperties
  );
  yield takeLatest(SET_USER_PROPERTY, saveUserProperty);
  yield takeLatest(LOGOUT, resetUserProperties);
}
